<div class="rightComp">
    <p>Nothing to see here!! You will see items here once they have been approved by the supervisor.</p>
</div>
